export default (initialState = {}, actionHandlers) => (
  state = initialState,
  action
) => {
  const handler = actionHandlers[action.type]
  // if (action.type === 'app/auth-set-tokens') debugger
  // console.log(handler, actionHandlers)
  return handler ? handler(state, action) : state
}
